export default {
  items: [
    {
      name: 'ABOUT US',
      dropDownItems: [
        {
          name: 'HUNTER/JUMPER 101',
          url: 'https://www.ushja.org/about-us-and-news/hunterjumper-101',
        },
        {
          name: 'Our Mission/History',
          url: 'https://www.ushja.org/about-us-and-news/our-missionhistory',
        },
        {
          name: 'Contact Us',
          url: 'https://www.ushja.org/contact-us',
        },
        {
          name: 'Board/Committee',
          url: 'https://www.ushja.org/about-us-and-news/committees',
          dropDownItems: [
            {
              name: 'Minutes',
              url: 'https://www.ushja.org/about-us-and-news/committees/minutes',
            },
            {
              name: 'Diversity and Inclusion Advocacy Resources',
              url:
                'https://www.ushja.org/about-us-and-news/committees/diversity-inclusion-resources',
            },
          ],
        },
        {
          name: 'Bylaws and Policies',
          url: 'https://www.ushja.org/about-us-and-news/policy-manual',
        },
        {
          name: 'Annual Meeting',
          url: 'https://www.ushja.org/about-us-and-news/annual-meeting',
        },
        {
          name: 'Sponsors and Partners',
          url: 'hhttps://www.ushja.org/about-us-and-news/sponsors-and-partners',
          dropDownItems: [
            {
              name: 'Sponsors',
              url:
                'https://www.ushja.org/about-us-and-news/sponsors-and-partners/sponsors',
            },
            {
              name: 'Educational Partners',
              url:
                'https://www.ushja.org/about-us-and-news/sponsors-and-partners/educational-partners',
            },
            {
              name: 'Member Partners (IEA and IHSA)',
              url:
                'https://www.ushja.org/about-us-and-news/sponsors-and-partners/member-partners-iea-and-ihsa',
            },
          ],
        },
        {
          name: 'Elections',
          url: 'https://www.ushja.org/about-us-and-news/elections',
          dropDownItems: [
            {
              name: 'Understanding USHJA Leadership Structure in 2020',
              url:
                'https://www.ushja.org/about-us-and-news/elections/understanding-ushja-leadership-structure',
            },
            {
              name: 'Zone Elections',
              url:
                'https://www.ushja.org/about-us-and-news/elections/zone-elections',
            },
          ],
        },
        {
          name: 'Town Halls',
          url: 'https://www.ushja.org/about-us-and-news/town-hall',
          dropDownItems: [
            {
              name: 'Virtual Town Halls',
              url:
                'https://www.ushja.org/about-us-and-news/town-hall/virtual-town-halls',
            },
          ],
        },
        {
          name: 'Careers',
          url: 'https://www.ushja.org/about-us-and-news/careers',
          dropDownItems: [
            {
              name: 'Want to Join the Team?',
              url:
                'https://www.ushja.org/about-us-and-news/careers/want-join-ushja',
            },
            {
              name: 'Inside the USHJA',
              url:
                'https://www.ushja.org/about-us-and-news/careers/inside-ushja',
            },
            {
              name: 'Open Positions',
              url:
                'https://www.ushja.org/about-us-and-news/careers/open-positions',
            },
          ],
        },
        {
          name: 'USHJA Staff Values',
          url: 'https://www.ushja.org/about-us-and-news/staff-values',
        },
        {
          name: 'Strategic Plan',
          url: 'https://www.ushja.org/about-us-and-news/strategic-plan',
        },
        {
          name: 'Financials',
          url: 'https://www.ushja.org/about-us-and-news/tax-statement',
        },
      ],
    },
    {
      name: 'MEMBERSHIP',
      dropDownItems: [
        {
          name: 'Join/Renew',
          url: 'https://www.ushja.org/membership/joinrenew',
          dropDownItems: [
            {
              name: 'Membership FAQ',
              url: 'https://www.ushja.org/membership/membership-faq',
            },
            {
              name: 'Print Member Card',
              url: 'https://www.ushja.org/membership/joinrenew/p',
            },
            {
              name: 'Update Information',
              url: 'https://data.ushja.org/membership/change-info.aspx',
            },
          ],
        },
        {
          name: 'Why Join?',
          url: 'https://www.ushja.org/membership/why-join',
        },
        {
          name: 'Join/Renew',
          url: 'https://www.ushja.org/membership/joinrenew',
          dropDownItems: [
            {
              name: 'Membership FAQ',
              url: 'https://www.ushja.org/membership/membership-faq',
            },
            {
              name: 'Print Member Card',
              url: 'https://www.ushja.org/membership/joinrenew/p',
            },
            {
              name: 'Update Information',
              url: 'https://data.ushja.org/membership/change-info.aspx',
            },
          ],
        },
        {
          name: 'Affiliates',
          url: 'https://www.ushja.org/membership/affiliates',
          dropDownItems: [
            {
              name: 'Affiliate Council',
              url:
                'https://www.ushja.org/membership/affiliates/affiliate-council',
            },
            {
              name: 'Find an Affiliate',
              url: 'https://www.ushja.org/membership/affiliates/find-affiliate',
            },
            {
              name: 'Affiliate Organization News',
              url: 'https://www.ushja.org/membership/affiliates/affiliate-news',
            },
            {
              name: 'Affiliate Awards',
              url:
                'https://www.ushja.org/membership/affiliates/affiliate-awards',
            },
            {
              name: 'Affiliate Organization Membership',
              url:
                'https://www.ushja.org/membership/affiliates/affiliate-association-membership',
            },
          ],
        },

        {
          name: 'Recognized Riding Academy',
          url: 'https://www.ushja.org/membership/recognized-riding-academy',
          dropDownItems: [
            {
              name: 'Application Requirements',
              url:
                'https://www.ushja.org/membership/recognized-riding-academy/application-requirements',
            },
            {
              name: 'Benefits',
              url:
                'https://www.ushja.org/membership/recognized-riding-academy/benefits',
            },
            {
              name: 'Application & Renewal Process',
              url:
                'https://www.ushja.org/membership/recognized-riding-academy/application-renewal-process',
            },
            {
              name: 'Recognized Riding Academy Listing',
              url:
                'https://www.ushja.org/membership/recognized-riding-academy/recognized-riding-academy-listing',
            },
          ],
        },

        {
          name: 'Horse Registration',
          url: 'https://www.ushja.org/membership/horses',
          dropDownItems: [
            {
              name: 'Register a Horse',
              url: 'https://www.ushja.org/membership/horses/register-horse',
            },
            {
              name: 'Change a Horse Name',
              url: 'https://www.ushja.org/membership/horses/change-horse-name',
            },
            {
              name: 'Transfer Ownership',
              url: 'https://www.ushja.org/membership/horses/transfer-ownership',
            },
            {
              name: 'Microchip',
              url: 'https://data.ushja.org/membership/microchip.aspx',
            },
            {
              name: 'Horse Registration FAQ',
              url:
                'https://www.ushja.org/membership/horses/horse-registration-faq',
            },
          ],
        },
      ],
    },
    {
      name: 'NEWS & MEDIA',
      dropDownItems: [
        {
          name: 'USHJA News',
          url: 'https://www.ushja.org/news/ushja-news-1',
        },
        {
          name: 'In Stride Magazine',
          url: 'https://www.ushja.org/news/stride-magazine',
        },
        {
          name: 'E-Newsletters',
          url: 'https://www.ushja.org/news/e-newsletters-1/e-newsletters',
          dropDownItems: [
            {
              name: 'E-News Update',
              url: 'https://www.ushja.org/news/e-newsletters-1/e-newsletters',
            },
          ],
        },
        {
          name: 'COVID-19 Resources',
          url: 'https://www.ushja.org/news/covid-19-resources',
        },
        {
          name: 'Safe Sport',
          url: 'https://www.ushja.org/education/resources/safe-sport',
        },
        {
          name: 'On Course Podcast',
          url: 'https://www.ushja.org/news/on-course-podcast',
        },
        {
          name: 'Video Library',
          url: 'https://www.ushja.org/video-library',
        },
      ],
    },
    {
      name: 'AWARDS & STANDINGS',
      dropDownItems: [
        {
          name: 'Standings/Point Based Awards',
          url:
            'https://www.ushja.org/awards-standings/point-basedstandings/zone-hoty-awards',
          dropDownItems: [
            {
              name: 'Zone HOTY',
              url:
                'https://www.ushja.org/awards-standings/point-basedstandings/zone-hoty-awards',
            },
            {
              name: `3'3" Jumping Seat Medal`,
              url:
                'https://ushja.org/competition/equitation/33-jumping-seat-medal/standings',
            },
            {
              name: 'Dash for Cash',
              url:
                'https://data.ushja.org/awards-standings/dash-for-cash.aspx?year=2021&section=3700&zone=0&standType=USHJADFC&bDate=9/16/2020&fDate=9/15/2021&TopDisp=30Due%20Date%207/16/2021',
            },
            {
              name: 'Green Hunter Incentive Program',
              url:
                'https://ushja.org/competition/hunter/green-hunter-incentive-program/standings',
            },
            {
              name: 'High Performance Jumper Clubs',
              url: 'https://data.ushja.org/awards-standings/jumper-clubs.aspx',
            },
            {
              name: 'International Hunter Derby',
              url:
                'https://www.ushja.org/awards-standings/point-basedstandings/zone-hoty-awards',
            },
            {
              name: 'Jumper Classic',
              url:
                'https://data.ushja.org/Awards-Standings/jumper-classic.aspx',
            },

            {
              name: 'National Hunter Derby',
              url:
                'https://www.ushja.org/competition/hunter/national-hunter-derby/standings',
            },
            {
              name: `Owner Recognition Award`,
              url:
                'https://www.ushja.org/awards-standings/point-basedstandings/owner-recognition-award',
            },
            {
              name: 'Outreach',
              url: 'https://data.ushja.org/awards-standings/outreach.aspx',
            },
            {
              name: 'Pony Hunter Derby',
              url:
                'https://www.ushja.org/competition/hunter/pony-hunter-derby/standings',
            },
            {
              name: 'High Performance Jumper Clubs',
              url: 'https://data.ushja.org/awards-standings/jumper-clubs.aspx',
            },
            {
              name: 'Rider Money Earned',
              url:
                'https://www.ushja.org/awards-standings/point-basedstandings/rider-money-earned',
            },
            {
              name: 'Show Jumping Rider Ranking List',
              url:
                'https://data.ushja.org/jumping/rider-ranking-list-standings.aspx',
            },

            {
              name: 'WCHR',
              url:
                'https://ushja.org/competition/hunter/world-championship-hunter-rider-program/standings',
            },
            {
              name: 'Zone Jumper Team Championships',
              url: 'https://data.ushja.org/zjtc/qualifying.aspx',
            },
          ],
        },
        {
          name: 'Merit Based Awards',
          url:
            'https://www.ushja.org/awards-standings/merit-based-awards/affiliate',
          dropDownItems: [
            {
              name: 'Affiliate',
              url:
                'https://www.ushja.org/awards-standings/merit-based-awards/affiliate',
            },
            {
              name: `President's Distinguished Service Awards`,
              url:
                'https://www.ushja.org/awards-standings/merit-based-awards/presidents-distinguished-service-awards',
            },
            {
              name: 'Nomination Based Awards',
              url:
                'https://www.ushja.org/awards-standings/awards/amateur-sportsmanship-award',
            },
          ],
        },
        {
          name: 'Nomination Based Awards',
          url:
            'https://www.ushja.org/awards-standings/awards/amateur-sportsmanship-award',
          dropDownItems: [
            {
              name: 'Amateur Sportsmanship Award',
              url:
                'https://www.ushja.org/awards-standings/awards/amateur-sportsmanship-award',
            },
            {
              name: 'Jane Marshall Dillon Award',
              url:
                'https://www.ushja.org/awards-standings/awards/jane-marshall-dillon',
            },
            {
              name: 'Lifetime Achievement Award',
              url:
                'https://www.ushja.org/awards-standings/awards/lifetime-achievement-award',
            },
            {
              name: 'Owners Legacy Award',
              url:
                'https://www.ushja.org/awards-standings/awards/owners-legacy',
            },

            {
              name: 'Vital Staff Award',
              url:
                'https://www.ushja.org/awards-standings/awards/vital-staff-award',
            },
            {
              name: 'Youth Awards',
              url: 'https://www.ushja.org/awards-standings/awards/youth',
            },
            {
              name: 'William J. Moroney Visionary Award',
              url:
                'https://www.ushja.org/awards-standings/awards/william-j-moroney-visionary-award',
            },
            {
              name: 'Licensed Official Emeritus Honorary Designation',
              url:
                'https://www.ushja.org/awards-standings/awards/licensed-official-emeritus',
            },
            {
              name: `J. Arthur “Bucky” Reynolds, II Award of Merit`,
              url:
                'https://www.ushja.org/awards-standings/awards/j-arthur-bucky-reynolds-ii-award-merit',
            },
          ],
        },
      ],
    },
    {
      name: 'COMPETITION',
      url: 'https://www.ushja.org/competition',
      dropDownItems: [
        {
          name: 'Competition Management Resources/Specifications',
          url:
            'https://www.ushja.org/competition/host-and-competition-management',
        },
        {
          name: 'Hunter',
          url: 'https://www.ushja.org/competition/hunter',
          dropDownItems: [
            {
              name: 'Green Hunter Incentive Program',
              url:
                'https://www.ushja.org/competition/hunter/green-hunter-incentive-program',
            },
            {
              name: 'Green Hunter Challenge',
              url:
                'https://www.ushja.org/competition/hunter/green-hunter-challenge',
            },
            {
              name: 'Hunter Team Challenge',
              url:
                'https://www.ushja.org/competition/hunter/hunter-team-challenge',
            },
            {
              name: 'Hunter Sections',
              url: 'https://www.ushja.org/competition/hunter/hunter-sections',
            },
            {
              name: 'International Hunter Derby',
              url:
                'https://www.ushja.org/competition/hunter/international-hunter-derby',
            },
            {
              name: 'National Hunter Derby',
              url:
                'https://www.ushja.org/competition/hunter/national-hunter-derby',
            },
            {
              name: 'Pony Hunter Derby',
              url: 'https://www.ushja.org/competition/hunter/pony-hunter-derby',
            },
            {
              name: 'Sallie B. Wheeler Hunter Breeding National Championship',
              url: 'https://www.ushja.org/competition/hunter/sallie-b-wheeler',
            },
            {
              name: 'World Championship Hunter Rider Program',
              url:
                'https://www.ushja.org/competition/hunter/world-championship-hunter-rider-program',
            },

            {
              name: 'Young Hunter Pony Championships',
              url:
                'https://www.ushja.org/competition/hunter/young-hunter-pony-championships',
            },
            {
              name: 'Hunter Education',
              url:
                'https://www.ushja.org/education/educational-forums/educational-webinars',
            },
          ],
        },
        {
          name: 'Jumper',
          url: 'https://www.ushja.org/competition/jumper',
          dropDownItems: [
            {
              name: 'Emerging Jumper Rider Program',
              url:
                'https://www.ushja.org/competition/jumper/emerging-jumper-rider-program',
            },
            {
              name: 'Zone Jumper Team Championships',
              url:
                'https://www.ushja.org/competition/jumper/zone-jumper-team-championships',
            },
            {
              name: 'Platinum Jumper Championships',
              url:
                'https://www.ushja.org/competition/jumper/platinum-jumper-championship',
            },
            {
              name: 'Show Jumping Rider Ranking List',
              url:
                'https://www.ushja.org/competition/jumper/rider-ranking-list',
            },
            {
              name: 'Jumper Classic Series',
              url: 'https://www.ushja.org/competition/jumper/jumper-classic',
            },
            {
              name: 'Young Jumper Championships',
              url:
                'https://www.ushja.org/competition/jumper/young-jumper-championships',
            },
            {
              name: 'Jumper Education',
              url:
                'https://www.ushja.org/education/educational-forums/educational-webinars',
            },
          ],
        },
        {
          name: 'Equitation',
          url: 'https://www.ushja.org/competition/equitation',
          dropDownItems: [
            {
              name: `3’3” Jumping Seat Medal`,
              url:
                'https://www.ushja.org/competition/equitation/33-jumping-seat-medal',
            },
            {
              name: 'Gladstone Cup',
              url: 'https://www.ushja.org/competition/equitation/gladstone-cup',
            },
            {
              name: `3'3" Hunter Seat Medal`,
              url:
                'https://www.ushja.org/competition/equitation/33-hunter-seat-medal',
            },
          ],
        },
        {
          name: 'National Championship',
          url: 'https://www.ushja.org/competition/national-championship',
          dropDownItems: [
            {
              name: `Qualifying`,
              url:
                'https://www.ushja.org/competition/national-championship/qualifying',
            },
          ],
        },
        {
          name: 'Outreach',
          url: 'https://www.ushja.org/competition/outreach',
          dropDownItems: [
            {
              name: `Calendar`,
              url: 'https://data.ushja.org/outreach/calendar.aspx',
            },
            {
              name: `FAQs`,
              url: 'https://www.ushja.org/competition/outreach/faqs',
            },
            {
              name: `Host/Management`,
              url: 'https://www.ushja.org/competition/outreach/hostmanagement',
            },
            {
              name: `Standings`,
              url: 'https://data.ushja.org/awards-standings/outreach.aspx',
            },
          ],
        },
        {
          name: 'Rules and Proposals',
          url: 'https://www.ushja.org/competition/rules-and-proposals/overview',
          dropDownItems: [
            {
              name: `Overview`,
              url:
                'https://www.ushja.org/competition/rules-and-proposals/overview',
            },
            {
              name: `Know Before You Show`,
              url:
                'https://www.ushja.org/competition/rules-and-proposals/upcoming-rules',
            },
            {
              name: `Rule Change Process`,
              url:
                'https://www.ushja.org/competition/rules-and-proposals/rule-change-process',
            },
            {
              name: `Microchipping 101`,
              url:
                'https://www.ushja.org/competition/rules-and-proposals/microchipping-101',
            },
          ],
        },
      ],
    },
    {
      name: 'EDUCATION',
      url: 'https://www.ushja.org/education',
      dropDownItems: [
        {
          name: 'Directory of Clinics',
          url: 'https://www.ushja.org/education/resources/directory-clinics',
        },
        {
          name: 'Emerging Athletes Program',
          url: 'https://www.ushja.org/education/emerging-athletes-program',
          dropDownItems: [
            {
              name: 'Apply',
              url: 'https://data.ushja.org/eap/application.aspx',
            },
            {
              name: 'Calendar',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/calendar',
            },
            {
              name: 'Regional Training Session',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/regional-training-session',
            },
            {
              name: 'National Training Session',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/national-training-session',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/specifications',
            },
            {
              name: 'Host/Management',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/hostmanagement',
            },
            {
              name: 'FAQ',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/faq',
            },
            {
              name: 'Clinician Bios',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/clinician-bios',
            },
            {
              name: 'Alumni',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/alumni',
            },
            {
              name: 'Mini EAP',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/mini-eap',
            },
            {
              name: 'Webinar',
              url:
                'https://www.ushja.org/education/emerging-athletes-program/webinar',
            },
          ],
        },
        {
          name: 'Educational Clinics',
          url: 'https://www.ushja.org/education/educational-forums',

          dropDownItems: [
            {
              name: 'Horsemanship Clinics',
              url:
                'https://www.ushja.org/education/educational-forums/educational-horsemanship-clinics',
            },
            {
              name: 'Webinars',
              url:
                'https://www.ushja.org/education/educational-forums/educational-webinars',
            },
            {
              name: 'Virtual Clinics',
              url: 'https://www.ushja.org/education/virtual-clinics',
            },
          ],
        },
        {
          name: 'Gold Star Clinics',
          url:
            'https://www.ushja.org/competition/jumper/emerging-jumper-rider-program/gold-star-clinic',
        },
        {
          name: 'Horsemanship Quiz Challenge',
          url: 'https://www.ushja.org/education/horsemanship-quiz-challenge',
          dropDownItems: [
            {
              name: 'Register',
              url:
                'https://www.ushja.org/education/horsemanship-quiz-challenge/register',
            },

            {
              name: 'Nationals',
              url:
                'https://www.ushja.org/education/horsemanship-quiz-challenge/nationals',
            },
            {
              name: 'FAQ',
              url:
                'https://www.ushja.org/education/horsemanship-quiz-challenge/faq',
            },
            {
              name: 'Practice Quiz',
              url: 'https://data.ushja.org/hqc/practice-quiz.aspx',
            },
            {
              name: 'Horsemanship Study Guide',
              url: 'https://www.ushja.org/download_file/684/0',
            },
            {
              name: 'Specifications',
              url: 'https://www.ushja.org/download_file/2065/0',
            },
            {
              name: 'Standings',
              url: 'https://data.ushja.org/awards-standings/hqc.aspx',
            },
            {
              name: 'Stable Challenge',
              url:
                'https://www.ushja.org/education/horsemanship-quiz-challenge/hqc-stable-challenge',
            },
            {
              name: 'Donate Now',
              url: 'https://www.ushja.org/foundation/donate',
            },
            {
              name: 'Adult Horsemanship Quiz Challenge',
              url:
                'https://www.ushja.org/education/horsemanship-quiz-challenge/adult-horsemanship-quiz-challenge',
            },
          ],
        },
        {
          name: 'Licensed Officials Education',
          url: 'https://www.ushja.org/education/licensed-officials-education',
          dropDownItems: [
            {
              name: 'Calendar',
              url:
                '/education/licensed-officials-education/calendar',
            },
            {
              name: 'Registration',
              url:
                'https://www.ushja.org/education/licensed-officials-education/registration',
            },
            {
              name: 'Resources',
              url:
                'https://www.ushja.org/education/licensed-officials-education/resources',
            },
          ],
        },
        {
          name: 'Recognized Riding Academy',
          url: 'https://www.ushja.org/education/recognized-riding-academy',
          dropDownItems: [
            {
              name: 'Application Requirements',
              url:
                'https://www.ushja.org/education/recognized-riding-academy/application-requirements',
            },
            {
              name: 'Benefits',
              url:
                'https://www.ushja.org/education/recognized-riding-academy/benefits',
            },
            {
              name: 'Application & Renewal Process',
              url:
                'https://www.ushja.org/education/recognized-riding-academy/application-renewal-process',
            },
            {
              name: 'Recognized Riding Academy Listing',
              url:
                'https://www.ushja.org/education/recognized-riding-academy/recognized-riding-academy-listing',
            },
          ],
        },
        {
          name: 'Instructor Credential',
          url: 'https://www.ushja.org/education/instructor-credential',

          dropDownItems: [
            {
              name: 'Certified Trainers Directory',
              url: 'https://data.ushja.org/tcp/search.aspx',
            },
            {
              name: 'Trainer Certification',
              url:
                'https://www.ushja.org/education/instructor-credential/trainer-certification',
            },
            {
              name: 'Benefits',
              url:
                'https://www.ushja.org/education/instructor-credential/benefits',
            },
            {
              name: 'Responsibilities',
              url:
                'https://www.ushja.org/education/instructor-credential/responsibilities',
            },
            {
              name: 'Renew',
              url:
                'https://www.ushja.org/education/instructor-credential/renew',
            },
            {
              name: 'FAQ',
              url: 'https://www.ushja.org/education/instructor-credential/faq',
            },
            {
              name: 'Resources',
              url:
                'https://www.ushja.org/education/instructor-credential/resources',
            },
          ],
        },
        {
          name: 'Sport History/Museum',
          url: 'https://www.ushja.org/education/sport-historymuseum',
          dropDownItems: [
            {
              name: 'Current Exhibit',
              url:
                'https://www.ushja.org/education/sport-historymuseum/current-exhibit',
            },
            {
              name: 'Past Exhibits',
              url:
                'https://www.ushja.org/education/sport-historymuseum/past-exhibits',
            },
            {
              name: 'Donate Today!',
              url: 'https://data.ushja.org/foundation/donate.aspx',
            },
            {
              name: 'Our Location',
              url:
                'https://www.ushja.org/education/sport-historymuseum/our-location',
            },
            {
              name: 'Museum Scavenger Hunt',
              url:
                'https://www.ushja.org/education/sport-historymuseum/museum-scavenger-hunt',
            },
          ],
        },
        {
          name: 'Resources',
          url: 'https://www.ushja.org/education/resources/best-practices',
          dropDownItems: [
            {
              name: 'Best Practices',
              url: 'https://www.ushja.org/education/resources/best-practices',
            },
            {
              name: 'Directory of Clinics',
              url:
                'https://www.ushja.org/education/resources/directory-clinics',
            },
            {
              name: 'Certified Trainers Directory',
              url: 'https://data.ushja.org/tcp/search.aspx',
            },
            {
              name: 'Recognized Riding Academy Listing',
              url:
                'https://www.ushja.org/education/recognized-riding-academy/recognized-riding-academy-listing',
            },
            {
              name: 'Safe Sport',
              url: 'https://www.ushja.org/education/resources/safe-sport',
            },
            {
              name: 'Equine Retirement Listing',
              url:
                'https://www.ushja.org/education/resources/equine-retirement-listing',
            },
            {
              name: 'Fun Stuff',
              url: 'https://www.ushja.org/education/resources/fun-stuff',
            },
          ],
        },
      ],
    },
    {
      name: 'ZONES & AFFILIATES',
      dropDownItems: [
        {
          name: 'Affiliates',
          url: 'https://www.ushja.org/membership/affiliates',
        },
        {
          name: 'Zone Overview & Map',
          url: 'https://ushja.org/zones-affiliates',
        },
        {
          name: 'Zone Council',
          url: 'https://data.ushja.org/about-us/committee-details.aspx?id=771',
        },
        {
          name: 'Zone Elections',
          url:
            'https://www.ushja.org/about-us-and-news/elections/zone-elections',
        },
        {
          name: 'Zone 1',
          url: 'https://www.ushja.org/zones-affiliates/zone-1',
          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=718',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-1/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-1/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-1/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-1/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-1/specifications',
            },
          ],
        },
        {
          name: 'Zone 2',
          url: 'https://www.ushja.org/zones-affiliates/zone-2',
          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=716',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-2/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-2/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-2/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-2/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-2/specifications',
            },
          ],
        },
        {
          name: 'Zone 3',
          url: 'https://www.ushja.org/zones-affiliates/zone-3',
          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=717',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-3/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-3/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-3/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-3/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-3/specifications',
            },
          ],
        },
        {
          name: 'Zone 4',
          url: 'https://www.ushja.org/zones-affiliates/zone-4',

          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=719',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-4/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-4/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-4/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-4/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-4/specifications',
            },
          ],
        },
        {
          name: 'Zone 5',
          url: 'https://www.ushja.org/zones-affiliates/zone-5',

          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=720',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-5/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-5/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-5/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-5/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-5/specifications',
            },
          ],
        },
        {
          name: 'Zone 6',
          url: 'https://www.ushja.org/zones-affiliates/zone-6',

          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=721',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-6/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-6/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-6/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-6/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-6/specifications',
            },
          ],
        },
        {
          name: 'Zone 7',
          url: 'https://www.ushja.org/zones-affiliates/zone-7',

          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=722',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-7/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-7/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-7/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-7/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-7/specifications',
            },
          ],
        },
        {
          name: 'Zone 8',
          url: 'https://www.ushja.org/zones-affiliates/zone-8',

          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=723',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-8/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-8/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-8/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-8/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-8/specifications',
            },
          ],
        },
        {
          name: 'Zone 9',
          url: 'https://www.ushja.org/zones-affiliates/zone-9',
          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=724',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-9/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-9/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-9/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-9/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-9/specifications',
            },
          ],
        },
        {
          name: 'Zone 10',
          url: 'https://www.ushja.org/zones-affiliates/zone-10',
          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=725',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-10/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-10/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-10/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-10/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-10/specifications',
            },
          ],
        },
        {
          name: 'Zone 11',
          url: 'https://www.ushja.org/zones-affiliates/zone-11',

          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=60',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-11/awards-standings',
            },
            // {
            //   name: 'Competition',
            //   url: 'https://www.ushja.org/zones-affiliates/zone-11/competition',
            // },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-11/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-11/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-11/specifications',
            },
          ],
        },
        {
          name: 'Zone 12',
          url: 'https://www.ushja.org/zones-affiliates/zone-12',
          dropDownItems: [
            {
              name: 'Committee',
              url:
                'https://data.ushja.org/about-us/committee-details.aspx?id=557',
            },
            {
              name: 'Awards & Standings',
              url:
                'https://www.ushja.org/zones-affiliates/zone-12/awards-standings',
            },
            {
              name: 'Competition',
              url: 'https://www.ushja.org/zones-affiliates/zone-12/competition',
            },
            {
              name: 'Grants & Scholarships',
              url:
                'https://www.ushja.org/zones-affiliates/zone-12/grants-scholarships',
            },
            {
              name: 'News',
              url: 'https://www.ushja.org/zones-affiliates/zone-12/news',
            },
            {
              name: 'Specifications',
              url:
                'https://www.ushja.org/zones-affiliates/zone-12/specifications',
            },
          ],
        },
        {
          name: 'Zone Specifications',
          url: 'https://www.ushja.org/zones-affiliates/zone-specifications',
        },
      ],
    },
    {
      name: 'FOUNDATION',
      url: 'https://ushja.org/foundation',
    },
    {
      name: 'H/J JOB BOARD',
      dropDownItems: [
        {
          name: 'Administrative/Office',
          url: 'https://www.ushja.org/ushja-job-board/administrativeoffice',
        },
        {
          name: 'Farm/Barn Manager',
          url: 'https://www.ushja.org/ushja-job-board/farmbarn-manager',
        },
        {
          name: 'Farm Worker/Groom',
          url: 'https://www.ushja.org/ushja-job-board/farm-workergroom',
        },
        {
          name: 'Instructor/Trainer',
          url: 'https://www.ushja.org/ushja-job-board/instructortrainer',
        },
        {
          name: 'Rider',
          url: 'https://www.ushja.org/ushja-job-board/rider',
        },
        {
          name: 'Intern/Working Student',
          url: 'https://www.ushja.org/ushja-job-board/internworking-student',
        },
        {
          name: 'Other',
          url: 'https://www.ushja.org/ushja-job-board/other',
        },
        {
          name: 'View All',
          url:
            'https://www.ushja.org/ushja-job-board/available-jobs-ushja-job-board',
        },
      ],
    },
  ],
};
